module.exports = __webpack_public_path__ + "static/media/download-white-icon.14e4f8e2.svg";